import React from 'react'
// @ts-ignore
import Drift from 'react-driftjs'
import { LiveChatProps } from './LiveChat.shared'

export const LiveChat: React.FC<LiveChatProps> = ({ userId, email }) => {
  return <Drift appId="96779e37swyg" userId={userId} attributes={{ email }} />
}
